import { render } from "./Zimbabwe.vue?vue&type=template&id=611a9e48"
import script from "./Zimbabwe.vue?vue&type=script&lang=js"
export * from "./Zimbabwe.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__